import { useState } from "react"

export default function BooleanField ({ value, className, children, onValueChanged, }) {
    const [isChecked, setIsChecked] = useState(value)
    
    return (
        <input value={value} type="checkbox" className={"cursor-pointer w-6 h-6"} onClick={()=>{onValueChanged(!isChecked); setIsChecked(!isChecked)}} />
    )
}